
import { Home, Play, Store, User, ReceiptText } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { useAuth } from '@/providers/AuthProvider';
import { isOrdersTabUser } from '@/config/features';

const BottomNavigation = () => {
  const location = useLocation();
  const { t } = useLanguage();
  const { user } = useAuth();
  const showOrdersTab = isOrdersTabUser(user?.email);

  const navItems = showOrdersTab
    ? [
        { icon: Home, label: t('home'), path: '/home' },
        { icon: Store, label: t('grocery'), path: '/grocery' },
        { icon: Play, label: 'Explore', path: '/explore' },
        { icon: ReceiptText, label: 'Orders', path: '/orders' },
        { icon: User, label: t('profile'), path: '/profile' },
      ]
    : [
        { icon: Home, label: t('home'), path: '/home' },
        { icon: Play, label: 'Explore', path: '/explore' },
        { icon: Store, label: t('grocery'), path: '/grocery' },
        { icon: User, label: t('profile'), path: '/profile' },
      ];


  const handleNavClick = (e: React.MouseEvent, path: string) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Only navigate if we're not already on that path
    if (location.pathname !== path) {
      window.history.pushState(null, '', path);
      window.dispatchEvent(new PopStateEvent('popstate'));
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-2 z-50">
      <div className="flex justify-around">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center py-2 px-3 rounded-lg transition-colors ${
                isActive 
                  ? 'text-red-600 bg-red-50' 
                  : 'text-gray-600 hover:text-red-600 hover:bg-red-50'
              }`}
              onClick={(e) => handleNavClick(e, item.path)}
            >
              <Icon className="h-6 w-6 mb-1" />
              <span className="text-xs font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNavigation;
